import React, {FunctionComponent} from 'react';
import {useSelector} from 'react-redux';
import {AnchorButton, Icon, Position} from '@blueprintjs/core';
import {IconNames} from '@blueprintjs/icons';
import {Tooltip2} from '@blueprintjs/popover2';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import {getBlockSelector} from '../../../store/reducers/blockReducer';

import './BlockOutput.scss';
import {getBlockTypeOutput} from '../utils';

interface BlockOutputProps {
  uid: string;
}

const toJinja = (text: string) => `{{ ${text} }}`;

const Output: FunctionComponent<any> = ({text}: any) => {
  return (
    <Tooltip2
      content="Copy Reference to Clipboard"
      hoverOpenDelay={500}
      placement={Position.BOTTOM}
      compact={true}
    >
      <CopyToClipboard text={toJinja(text)}>
        <AnchorButton
          minimal={true}
          text={text}
        />
      </CopyToClipboard>
    </Tooltip2>
  );
};

export const BlockOutput = ({
  uid,
}: BlockOutputProps) => {
  const block = useSelector(getBlockSelector(uid));

  if (!block) {
    return null;
  }
  const name = block?.name as string;

  return (
    <div className="block-output">
      <Icon icon={IconNames.NEST}/>
      <Output text={name}/>
      {
        getBlockTypeOutput(block?.type as any)
          .map((output: string, index) =>
            <Output
              text={name + '.' + output}
              key={index}
            />
          )
      }
    </div>
  );
};

export default BlockOutput;
